<div class="upload-portfolio-container">
    <div class="text-center font-20 margin-bottom"> File upload</div>

    <div class="file display-flex-column border-dashed-gray align-items-center pad-32 width-80 margin-auto" 
    [class.dragover]="isDragOver" (dragover)="onDragOver($event)" (drop)="onDrop($event)" (dragleave)="onDragLeave($event)">
       <div class="mat-icon-100">
        <mat-icon class="margin-4-right">
            upload_file
        </mat-icon>
       </div>
       <div class="font-14">Drag and drop or <span class="text-accent decoration-underline cursor-pointer" (click)="fileInput?.click()">browse</span> your files</div>
       <div class="font-14 margin-8-top placeholder-text">File Supported: .json</div>
    </div>

    <input type="file" #fileInput class="display-none" (change)="onFileSelected($event)">

    <div class="file-selected margin-vr text-center" *ngIf="selectedFile">File selected : <span class="text-accent font-bold">{{selectedFile?.name}}</span></div>

    <div class="flex-centered-container margin-vr">
        <button mat-flat-button color="accent" class="margin-hr" (click)="uploadPortfolio()" [disabled]="!selectedFile">Upload</button>
        <button mat-flat-button color="warn" (click)="closeDialog()">Cancel</button>
    </div>
</div>